import { Assets } from '../core/Assets';
import { Cosmocostaud } from './Cosmocostaud';

export class Hammer {
    public angle                                : number;
    private _maxAngle                           : number;
    private _hammer                             : PIXI.Sprite; // thor's hammer
    private _cosmocostaud                       : Cosmocostaud; // Game
    
    constructor() {
        this.angle = 0
        this._maxAngle = -70;
        this._hammer = Assets.sprites['marteau']; 
        this._cosmocostaud = Cosmocostaud.instance;
    }
    
    // update hammer details
    private _raise() {
        this._hammer.x -= 1.5; // offset hammer a little for realism
        this.angle -= 1; // hammer rotation
    };
    
    public get el(): any { return this._hammer; }

    public handle(skipAnim) {
        // Prevent hammer from going too far 
        if (!(this.angle <= this._maxAngle) && !skipAnim) {
            this._raise();
            Assets.sounds['clic_marteau'].play();
        } 
        TweenMax.to(this._hammer, 0.5, { rotation: this.angle * (Math.PI / 180), ease: Expo.easeOut });
    };

    // if no click, reduce hammer angle
    public release() {
        this._hammer.x += 1.5/8; // offset hammer a little for smooth release
        this.angle += 1/8; // smooth hammer rotation
        this.handle(true);
    };

    // On timer end, strike hammer, hide elements and start animations
    public strike(e) {
        this.handle(true);
        
        TweenMax.to(this._hammer, 0.1, { x: this._cosmocostaud.screenWidth/2 - this._hammer.width + 35, rotation: 3 * (Math.PI / 180), ease: Expo.easeOut, onComplete: function() {
            Assets.sounds['hammertime'].play();
            this._cosmocostaud.buttonEl.gotoAndStop(6); // press button
            TweenMax.to(this._cosmocostaud.buttonEl, 2, { y: this._cosmocostaud.screenHeight * 2 + this._cosmocostaud.buttonEl.height, ease: Expo.easeOut });
            TweenMax.to(this._hammer, 2, { y: this._cosmocostaud.screenHeight * 2 + this._hammer.height, ease: Expo.easeOut });
            
            this._cosmocostaud.positionSpaceMarine();
            this._cosmocostaud.handlePropulsion(e);
        }.bind(this), delay: 0.5 }); 
    };

}